import KendoNumericTextBox from '../KendoNumericTextBox'
import KendoColorPicker from '../KendoColorPicker'
import KendoColorPalette from '../KendoColorPalette'
import KendoFlatColorPicker from '../KendoFlatColorPicker'
import KendoMaskedTextBox from '../KendoMaskedTextBox'
import KendoSlider from '../KendoSlider'
import KendoRangeSlider from '../KendoRangeSlider'
import KendoSwitch from '../KendoSwitch'

let KendoInputsInstaller = class {
    static install(Vue) {
        Vue.component(KendoNumericTextBox.name, KendoNumericTextBox)
        Vue.component(KendoColorPicker.name, KendoColorPicker)
        Vue.component(KendoColorPalette.name, KendoColorPalette)
        Vue.component(KendoFlatColorPicker.name, KendoFlatColorPicker)
        Vue.component(KendoMaskedTextBox.name, KendoMaskedTextBox)
        Vue.component(KendoSlider.name, KendoSlider)
        Vue.component(KendoRangeSlider.name, KendoRangeSlider)
        Vue.component(KendoSwitch.name, KendoSwitch)
    }
}

export default KendoInputsInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoInputsInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/kendo-inputs-installer/index.js